import { memo } from "react";

import StandardHeaderBackButton from "@/components/molecules/StandardHeaderBackButton";
import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";
import { Text } from "@/components/atoms/Text";
import type { TextVariant } from "@/components/atoms/types";

import { ifWeb } from "@/utils/platform";

/**
 *
 */
export interface IForm {
  code: string;
}

/**
 *
 */
interface Props {
  title: string;
  subTitle: string;
  backToSignIn?: boolean;
  isDisableButtonBack?: boolean;
}

/**
 * View component for authentication screen header with title, subtitle, and optional back button
 * @param root0 - Component props
 * @param root0.title - Main heading text displayed at the top of the auth screen
 * @param root0.subTitle - Secondary text providing additional context below the title
 * @param root0.backToSignIn - Boolean indicating whether to show the back to sign in button
 * @param root0.isDisableButtonBack - Boolean indicating whether the back button should be disabled
 */
const HeaderView = ({
  title,
  subTitle,
  backToSignIn,
  isDisableButtonBack,
}: Props) => (
  <Stack className="items-center gap-3 pb-4">
    <Stack direction="horizontal" className="relative w-full">
      {backToSignIn && (
        <Box className="absolute inset-y-0 left-0 z-10 justify-center">
          <StandardHeaderBackButton disabled={isDisableButtonBack} />
        </Box>
      )}
      <Text
        variant={ifWeb<TextVariant>("title-lg", "display-sm")}
        className="flex-1 text-center text-content-primary"
      >
        {title}
      </Text>
    </Stack>
    {/* SE-6773: the web arm used to name an `md` size step, for which this
        theme has no fontSize token — so it compiled to nothing and the element
        rendered at the Text atom's own default (size "md" -> text-title-sm).
        Naming that default keeps the render identical. */}
    <Text
      variant="unstyled"
      className={`text-center font-body ${ifWeb("text-title-sm", "text-title")}`}
    >
      {subTitle}
    </Text>
  </Stack>
);

HeaderView.displayName = "HeaderView";

export default memo(HeaderView);
